/**
 * AiSuggestion_Service.ts
 * ──────────────────────────────────────────────────────────────────────────
 * REAL AI (Claude) suggestion generation.
 *   POST /api/v1/items/:id/suggestions/generate
 *
 * Separate from Suggestion_Service.ts (which handles the manual create + the
 * review lifecycle: list / accept / reject). This file owns ONLY the
 * Claude-backed generation call. URLs come from the centralized
 * Api_Endpoints.ts — never hardcoded here.
 * ──────────────────────────────────────────────────────────────────────────
 */

import axiosInstance from '../../api/axiosInstance';
import { Catalog_Item_Suggestions_Generate_Url } from '../../api/endpoints';
import { GenerateSuggestionsResponse } from '../../schemas/catalog/aiSuggestion';

/**
 * Ask the backend to generate AI suggestions for an item. The backend calls
 * Claude, persists the valid/non-duplicate proposals as PENDING, and returns
 * them. Throws on transport/HTTP errors — callers surface via Error_Handler.
 */
export const generateSuggestions = async (
  itemId: string,
): Promise<GenerateSuggestionsResponse> => {
  const { data } = await axiosInstance.post<GenerateSuggestionsResponse>(
    Catalog_Item_Suggestions_Generate_Url(itemId),
  );
  return data;
};
